import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-new-change-password',
  templateUrl: './new-change-password.component.html',
  styleUrls: ['./new-change-password.component.scss']
})
export class NewChangePasswordComponent implements OnInit {

  changePassword: FormGroup;
  submitted = false;

  constructor(
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private auth: AuthServiceService
  ) { }

  ngOnInit(): void {
    this.changePassword = this.formBuilder.group({
      old_password: ['', [Validators.required, Validators.minLength(5)]],
      new_password: ['', [Validators.required, Validators.minLength(5)]],
      confirm_password: ['', [Validators.required, Validators.minLength(5)]]
    });
  }

  get changeV() {
    return this.changePassword.controls;
  }

  dismiss() {
    this.modalService.dismissAll();
  }

  change_password() {
    this.submitted = true;

    if (this.changePassword.invalid) {
      return false;
    }
    
    let old_password = this.changePassword.value.old_password;
    let new_password = this.changePassword.value.new_password;
    let confirm_password = this.changePassword.value.confirm_password;
    
    // if(new_password.trim() != confirm_password.trim()) {
    //   return this.toastr.error('Passwords do not match.');
    // }

    let formData = new FormData();
    formData.append('oldPassword', old_password);
    formData.append('newPassword', new_password);
    formData.append('confirmPassword', confirm_password);

    this.auth.change_password(formData).subscribe((response: any) => {

      this.modalService.dismissAll();
      
      Swal.fire(
        'Success',
        response.message,
        'success'
      ).then(() => {
        window.location.reload();
      });

    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message)
      }
    });

  }

}
